import { render, staticRenderFns } from "./DocHubResourceItem.vue?vue&type=template&id=026edba0"
import script from "./DocHubResourceItem.vue?vue&type=script&lang=js"
export * from "./DocHubResourceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports